import useAuth from 'hooks/useAuth';
import { useQuery } from 'react-query';

export default function useInformedConsent(therapistId, patientId) {
  const { request, userId } = useAuth();

  const {
    data: informedConsents,
    refetch,
    isLoading: listLoading,
    isFetching
  } = useQuery(
    `/therapists/${therapistId}/patients/${patientId}/informed-consent-history`,
    () =>
      request
        .get(`/therapists/${therapistId}/patients/${patientId}/informed-consent-history`)
        .then((response) => response.data.informedConsentHistory as any),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      enabled: Boolean(therapistId && patientId)
    }
  );

  return {
    informedConsents,
    isLoading: isFetching || listLoading
  };
}
